var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content-container"
  }, [_vm.isShownDescription || _vm.isShownContentUrl ? _c('div', {
    staticClass: "content-section description"
  }, [_c('div', {
    staticClass: "section-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('bill.description'))
    }
  }), _c('div', {
    staticClass: "section-content"
  }, [_vm.transaction.description ? _vm._l(_vm.splitedDescription, function (description) {
    return _c('p', {
      key: description,
      staticClass: "section-description",
      domProps: {
        "textContent": _vm._s(description)
      }
    });
  }) : _vm._e(), _vm.isShownContentUrl ? [_c('p', {
    staticClass: "section-url"
  }, [_c('a', {
    domProps: {
      "textContent": _vm._s(_vm.$t('realised.content'))
    },
    on: {
      "click": function click($event) {
        return _vm.$openLink(_vm.getContentUrlByCasualType, true, true);
      }
    }
  })])] : _vm._e()], 2)]) : _vm._e(), _vm.isTips ? _c('div', {
    staticClass: "content-section tips"
  }, [_c('div', {
    staticClass: "section-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('bill.tips.section.title'))
    }
  }), _c('div', {
    staticClass: "section-content"
  }, [_c('div', {
    class: _vm.$style.tipsSection
  }, [_vm._l(_vm.tipsVariants, function (tip, idx) {
    return _c('div', {
      key: idx,
      class: _vm.$style.tipsVariant,
      domProps: {
        "textContent": _vm._s(tip)
      }
    });
  }), _vm.permission ? _c('div', {
    directives: [{
      name: "cursor",
      rawName: "v-cursor:pointer",
      arg: "pointer"
    }],
    class: _vm.$style.tipsVariant,
    on: {
      "click": _vm.handleChangeTipsVariants
    }
  }, [_c('base-icon', {
    attrs: {
      "name": "basic_pen-create",
      "size": 14
    }
  })], 1) : _vm._e()], 2)])]) : _vm._e(), _vm.isSubscription || _vm.isTariff || _vm.isTicket ? _vm._l(_vm.billTariffs, function (tariff) {
    return _c('bill-tariff', {
      key: tariff.id,
      attrs: {
        "transaction": _vm.transaction,
        "tariff": tariff,
        "permission": _vm.permission
      }
    });
  }) : _vm._e(), _vm.transaction.multiBill ? _c('div', {
    staticClass: "content-section multi-transaction"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v(_vm._s(_vm.$t('payments.intake')))]), _c('div', {
    staticClass: "section-content"
  }, [_vm.transaction.billPaymentEnabled ? _c('span', [_vm._v(" " + _vm._s(_vm.$t('common.actived')) + " ")]) : _c('span', {
    staticStyle: {
      "color": "#FF5172"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.stopped')) + " ")]), _vm.permission ? _c('button', {
    class: "icon-multi-".concat([_vm.transaction.billPaymentEnabled ? 'off' : 'on']),
    on: {
      "click": _vm.onToggleMultipay
    }
  }) : _vm._e()])]) : _vm._e(), _vm.isShownMakerPublishing ? _c('div', {
    staticClass: "content-section marketplace-transaction"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('a', {
    attrs: {
      "href": _vm.marketplaceUrl,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Capusta.Maker")])]), _c('div', {
    staticClass: "section-content"
  }, [_vm.transaction.onMarketplace ? _c('span', {
    staticClass: "marketplace-publish-container",
    on: {
      "click": _vm.onChangeMarketplaceCategory
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.displayMarketplaceCategory)) + " ")]) : _c('span', {
    staticClass: "marketplace-unpublish-container"
  }, [_vm._v(" " + _vm._s(_vm.$t('not.published')) + " ")]), _vm.permission ? _c('button', {
    class: "icon-multi-".concat([_vm.transaction.onMarketplace ? 'off' : 'on']),
    on: {
      "click": _vm.onToggleMarketplace
    }
  }) : _vm._e()])]) : _vm._e(), _vm.isShownPromoCode ? _c('div', {
    staticClass: "content-section promocode-coupon"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v(_vm._s(_vm.$t('promocode.usage')))]), _c('div', {
    staticClass: "section-content"
  }, [_c('div', [_vm._v(_vm._s(_vm.applyPromoCode ? _vm.$t('common.allowed') : _vm.$t('common.denied')))]), _vm.permission ? _c('button', {
    class: "icon-multi-".concat([_vm.applyPromoCode ? 'off' : 'on']),
    on: {
      "click": _vm.onTogglePromoCodePermission
    }
  }) : _vm._e()])]) : _vm._e(), _vm.transaction.public_id ? _c('div', {
    staticClass: "content-section transaction-link"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v(_vm._s(_vm.$t('link.for.pay')))]), _c('div', {
    staticClass: "section-content"
  }, [_c('a', {
    ref: "code",
    attrs: {
      "href": _vm.transaction.payLink,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.transaction.payLink))]), _vm.permission ? _c('button', {
    staticClass: "icon-copy",
    on: {
      "click": _vm.onCopy
    }
  }) : _vm._e()])]) : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }